import styles from './DataTablePaginationV2.styles.scss';
import { DataTablePaginationV2Component, dataTablePaginationV2Template } from './DataTablePaginationV2';
export const chameleonDataTablePaginationV2 = DataTablePaginationV2Component.compose({
    baseName: 'data-table-pagination-v2',
    template: dataTablePaginationV2Template,
    styles,
});
